// extracted by mini-css-extract-plugin
export default {"logo":"Auth_logo__WaS5L"};